import { render, staticRenderFns } from "./VistaModelo.vue?vue&type=template&id=331c6566&scoped=true&"
import script from "./VistaModelo.vue?vue&type=script&lang=js&"
export * from "./VistaModelo.vue?vue&type=script&lang=js&"
import style0 from "./VistaModelo.vue?vue&type=style&index=0&id=331c6566&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "331c6566",
  null
  
)

export default component.exports